import { utils } from '@sfaas/util';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getPopupParts: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.partNo !== undefined) {
			queryStr = objectToQuerystring({
				stdDt: searchParams.stdDt,
				partNo: searchParams.partNo,
				opCd: searchParams.opCd,
				pwaYn: searchParams.pwaYn,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/commpopup/partPopup/v1/asPartInfos` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
